<form
  [formGroup]="form"
  (ngSubmit)="onSave()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div
      id="header"
      class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
      <span class="text-[18px] font-black">
        <i
          [class.pi]="true"
          [class.pi-file-arrow-up]="true"
          style="font-size: 2rem"></i>
        DESPLEGAR SISTEMA DE IA
      </span>
      <div
        id="buttons"
        class="flex gap-4">
        <app-buttons
          [label]="'Cancelar'"
          (click)="cancel()" />
        <app-buttons
          [label]="'Continuar'"
          [disabled]="form.invalid"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 1 de 6</span>
      <h1 class="font-bold text-[30px] pb-8">Desplegar sistema de IA</h1>

      <h2 class="font-bold text-[24px] pb-6">Gestión del riesgo</h2>

      <div class="text-[16px]">
        Sesgos identificados
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </div>
      <desy-textarea
        formControlName="biases"
        placeholder="Sesgos identificados en los datos de entrenamiento o en la salida del modelo."
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="5"
        [maxlength]="1000"></desy-textarea>
      <ng-container *ngIf="getError(form, 'biases', formSubmitted()) as error; else biasesInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #biasesInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 1000 caracteres</span>
      </ng-template>

      <div class="text-[16px] mt-4">
        Riesgos identificados
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </div>
      <desy-textarea
        formControlName="risks"
        placeholder="Riesgos que se han detectado durante la evaluación, diseño, entrenamiento o despliegue del sistema de IA."
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="5"
        [maxlength]="1000"></desy-textarea>
      <ng-container *ngIf="getError(form, 'risks', formSubmitted()) as error; else risksInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #risksInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 1000 caracteres</span>
      </ng-template>
    </div>
  </div>
</form>
